import { fetchConToken } from '../helpers/fetch';
import { openModalBottom } from './ui';

// El backend responde cuando ha terminado de enviar el correo, y en rangos amplios eso dura lo
// mismo que la consulta de ventas: el mismo margen que la carga de la tabla de facturación.
export const TIMEOUT_ENVIO_LISTADO_MS = 300000;

const RUTA_ENVIO_LISTADO_CLIENTES = 'listados/clientes/enviar';
const RUTA_ENVIO_LISTADO_FACTURACION = 'listados/facturacion/enviar';

const SEGUNDOS_AVISO_ENVIO = 5;
const NOMBRE_ERROR_TIEMPO_AGOTADO = 'AbortError';

const MENSAJE_ERROR_ENVIO = 'No se ha podido enviar el listado por email';
// Al agotarse la espera el servidor puede haber enviado el correo igualmente: no se afirma que
// haya fallado, solo que no se ha podido confirmar.
const MENSAJE_ENVIO_SIN_CONFIRMAR =
    'No se ha podido confirmar el envío del listado. Si no te llega en unos minutos, vuelve a intentarlo';

const mensajeConfirmacion = (email) => `Te hemos enviado el listado a ${email}`;

// Los 400 de validación llegan sin `msg`, con un objeto por campo (`validarCampos`).
const primerMensajeDeValidacion = (erroresPorCampo) => {
    const errores = Object.values(erroresPorCampo || {});
    const primerErrorConMensaje = errores.find((error) => error?.msg);
    return primerErrorConMensaje?.msg;
};

const mensajeDeErrorDelServidor = (body) =>
    body?.msg || primerMensajeDeValidacion(body?.errors) || MENSAJE_ERROR_ENVIO;

const mensajeDeExcepcion = (error) =>
    error?.name === NOMBRE_ERROR_TIEMPO_AGOTADO ? MENSAJE_ENVIO_SIN_CONFIRMAR : MENSAJE_ERROR_ENVIO;

const avisar = (dispatch, mensaje) => dispatch(openModalBottom({ text: [mensaje], timeOut: SEGUNDOS_AVISO_ENVIO }));

const enviarListado = (ruta, filtros) => {
    return async (dispatch) => {
        try {
            const resp = await fetchConToken(ruta, filtros, 'POST', TIMEOUT_ENVIO_LISTADO_MS);
            const body = await resp.json();
            const envioConfirmado = body?.ok === true;
            if (!envioConfirmado) {
                avisar(dispatch, mensajeDeErrorDelServidor(body));
                return { ok: false };
            }
            avisar(dispatch, mensajeConfirmacion(body.email));
            return { ok: true, email: body.email };
        } catch (error) {
            avisar(dispatch, mensajeDeExcepcion(error));
            return { ok: false };
        }
    };
};

export const startEnviarListadoClientes = () => enviarListado(RUTA_ENVIO_LISTADO_CLIENTES, {});

/**
 * @param {object} filtros - salida de `construirFiltrosListadoFacturacion`.
 */
export const startEnviarListadoFacturacion = (filtros) => enviarListado(RUTA_ENVIO_LISTADO_FACTURACION, filtros);
